"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./FileUpload.css");
var Utils = require("player-core/utils");
var FileUpload = (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.ENTERKEY = 13;
        _this.id = _this.props.id ? _this.props.id : "radio_" + Utils.createUUID();
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }
    FileUpload.prototype.onChange = function (e) {
        e.preventDefault();
        this.props.onChange && this.props.onChange(e.target.files);
        this.forceUpdate();
    };
    FileUpload.prototype.onKeyUp = function (e) {
        if (e.keyCode === this.ENTERKEY) {
            e.preventDefault();
            e.currentTarget.click();
        }
    };
    FileUpload.prototype.getLabelProps = function () {
        return {
            className: (this.props.errorMessage) ? 'p-file-upload is-invalid' : 'p-file-upload',
            htmlFor: this.id,
            onKeyUp: this.onKeyUp
        };
    };
    FileUpload.prototype.getInputProps = function () {
        var _a = this.props, name = _a.name, multiple = _a.multiple, isEnabled = _a.isEnabled, accept = _a.accept, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, children = _a.children;
        var props = {
            name: name, multiple: multiple,
            id: this.id,
            disabled: !isEnabled,
            className: 'p-file-upload-input',
            type: 'file',
            accept: accept && accept.join(', '),
            onChange: this.onChange,
            value: '',
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabelledBy
        };
        if (children) {
            props.className += ' hidden';
            props['aria-hidden'] = true;
            props['tabIndex'] = -1;
        }
        return props;
    };
    FileUpload.prototype.render = function () {
        var _a = this.props, label = _a.label, showLabel = _a.showLabel, isRequired = _a.isRequired, description = _a.description, errorMessage = _a.errorMessage, tag = _a.tag, children = _a.children;
        return (React.createElement("div", { "data-tag": tag },
            React.createElement("label", __assign({}, this.getLabelProps()),
                (showLabel && label) &&
                    React.createElement("label", { htmlFor: this.id, className: "p-file-upload-label p-t-grey40" },
                        label,
                        isRequired && React.createElement("span", { className: "p-file-upload-required p-t-error50" }, "*")),
                React.createElement("input", __assign({}, this.getInputProps())),
                children),
            description ? React.createElement("p", { className: "p-file-upload-description" }, description) : null,
            errorMessage ? React.createElement("p", { id: this.id + "-error", className: "p-file-upload-error p-t-error50" }, errorMessage) : null));
    };
    return FileUpload;
}(React.Component));
FileUpload.defaultProps = {
    id: '',
    name: '',
    isEnabled: true,
    label: '',
    showLabel: true,
    isRequired: false,
    description: '',
    errorMessage: '',
    ariaLabel: '',
    ariaLabelledBy: '',
    multiple: false,
    accept: [],
    tag: null,
    children: undefined,
    onChange: void (0)
};
exports.default = FileUpload;
//# sourceMappingURL=FileUpload.js.map


//////////////////
// WEBPACK FOOTER
// ../player-file-upload/build/control/FileUpload.js
// module id = 307
// module chunks = 0 2